import React from 'react';
import { Modal, Fade, Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      display: 'flex',
      flexDirection: 'Column',
      width: 'fit-content',
      borderRadius: 4,
      padding: 0,
      margin: isMobile ? 10 : 0,
      boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
      backgroundColor: 'white',
      '&:focus': {
        outline: 'none',
      },
    },
    infoWrapper: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'flex-start',
      width: 'fit-content'
    },
    closeContainer: {
      cursor: 'pointer',
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    close: {
      margin: '24px 24px 0 0',
    }
})

function FilterModal({ 
    open,
    content,
    handleClose,
  })
{
    const classes = useStyles()
 
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open ? open : false}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open ? open : false}>
          <div className={classes.paper}>
            <div className={classes.infoWrapper}>
              <div
                onClick={handleClose}
                className={classes.closeContainer}
              >
                <img
                  src="/img/icons/close.svg"
                  alt="close"
                  className={classes.close}
                />
              </div>
              {content && content}
            </div>
          </div>
        </Fade>
      </Modal>
    )
}

export default FilterModal;
